import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderType: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    clearOrderType: (state) => {
      state.orderType = null;
    },
  },
});

export const { setOrderType, clearOrderType } = orderSlice.actions;
export default orderSlice.reducer;